module.exports = __webpack_public_path__ + "static/film5-0372e79349e5aa96b7e889def99add3d.jpg";